import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { XIcon } from '@heroicons/react/solid';
import { Transition } from '@headlessui/react'

export default class Alert extends React.Component
{
    static propTypes = {
        title: PropTypes.string.isRequired,
        close: PropTypes.func.isRequired,

        icon: PropTypes.any,
        description: PropTypes.string,
    };

    static defaultProps = {
        icon: null,
        description: null
    };

    static transitions = {
        appear: true,
        show: true,
        enter: "transform ease-out duration-300 transition",
        enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:-translate-x-2",
        enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
        leave: "transition ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
    };

    render()
    {
        return <div className="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:justify-start">
            <Transition as={React.Fragment} {...Alert.transitions}>
                { ref => <div ref={ref} className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto">
                    <div className="rounded-lg shadow-xs overflow-hidden">
                        <div className="p-4">
                            <div className="flex items-start">
                                { this.renderIcon() }
                                <div className="ml-3 w-0 flex-1 pt-0.5">
                                    <p className="text-sm leading-5 font-medium text-gray-900">
                                        { this.props.title }
                                    </p>
                                    { this.renderDescription() }
                                </div>
                                <div className="ml-4 flex-shrink-0 flex">
                                    { this.renderCloseButton() }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            </Transition>
        </div>;
    }

    renderIcon()
    {
        if (! this.props.icon) {
            return null;
        }

        return <div className="flex-shrink-0">
            { this.props.icon }
        </div>;
    }

    renderDescription()
    {
        if (! this.props.description) {
            return null;
        }

        return <p className="mt-1 text-sm leading-5 text-gray-500">
            { this.props.description }
        </p>
    }

    renderCloseButton()
    {
        return <button onClick={this.props.close} className="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150">
            <XIcon className="h-5 w-5" />
        </button>;
    }
}
